export const ADD_USER = 'USERS::ADD';
export const START_LOADING = 'USERS::START-LOADING';
export const END_LOADING = 'USERS::END-LOADING';
export const OPEN_MODAL = 'USERS::OPEN-MODAL';
export const CLOSE_MODAL = 'USERS::CLOASE-MODAL';
export const SNAP_TIMESTAMP = 'SNAP_TIMESTAMP';




// WEBPACK FOOTER //
// ./src/actions/types.js